import {
  FulfillmentTypes,
  PrintServiceProductEntityHydrated,
} from "@jackfruit/common"
import { useAllProducts } from "./useAllProducts"
import { usePage } from "./usePage"

export const useCurrentAvailableProductsForPageRegardlessOfFulfillment = () => {
  const allProducts = useAllProducts()
  const { page } = usePage()

  const {
    products: productConfiguration,
    printServices: printServiceConfiguration,
  } = page

  const allPrintServices = Object.values(printServiceConfiguration).flatMap(
    services => services
  )

  const allProductsConfigurationForPage = allPrintServices
    .map(printService => {
      return productConfiguration[
        printService.fulfillmentType as FulfillmentTypes
      ][printService.id]
    })
    .flatMap(Object.values)

  const products = allProductsConfigurationForPage
    .map(productConfiguration => {
      return allProducts[
        productConfiguration.id
      ] as PrintServiceProductEntityHydrated
    })
    .filter(product => product !== undefined)

  return { products }
}
